import React, { useState, useEffect, useRef } from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import stringHelper from '../../../../Helpers/stringHelper';
import ErrorMessage from '../../../ErrorMessage';
import UserService from '../../../../Services/userService';

function OutsourcedUserSelect({ value, className, fieldName, onChange, filterCleared, changeOfEditedMultipItem }) {
  const [selectValues, setSelectValues] = useState([]);
  const usersRef = useRef([]);

  useEffect(() => {
    UserService.GetUserList(true)
      .then((result) => {
        const outsourcedUsers = result
          .filter((user) => user.isOutsourcedEmployee === true && user.isActive)
          .sort((a, b) =>
            `${a.lastName} ${a.firstName}`.toLocaleLowerCase() > `${b.lastName} ${b.firstName}`.toLocaleLowerCase()
              ? 1
              : -1
          );
        usersRef.current = outsourcedUsers;
        const optValues = [{ label: 'Choose one...', value: '', disabled: true }];
        outsourcedUsers.forEach((user) => {
          optValues.push({
            label: `${user.firstName} ${user.lastName}${stringHelper.toBracket(user.userName)}`,
            value: user.userId,
            disabled: false,
          });
        });
        setSelectValues(optValues);
      })
      .catch((ex) => {
        setSelectValues([]);
        ErrorMessage.SetErrorMessage('OUS32', ex);
      });
  }, []);

  const handleChange = (fName, newValue) => {
    const user = usersRef.current.find((u) => String(u.userId) === String(newValue));
    if (user && changeOfEditedMultipItem) {
      changeOfEditedMultipItem([
        { fieldName: fName, newValue: newValue },
        { fieldName: '_userOfficeId', newValue: user.officeId },
        { fieldName: 'HiringOfficeId', newValue: user.officeId },
      ]);
    } else {
      onChange(fName, newValue);
    }
  };

  return (
    <SelectFieldCheckbox
      value={value}
      className={className || 'w-100 form-control form-control-sm'}
      fieldName={fieldName}
      onChange={handleChange}
      filterCleared={filterCleared}
      selectValues={selectValues}
    />
  );
}

export default OutsourcedUserSelect;
